/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Step 5 (Cut Review) exception status for a composite. cutSelected: at least one data cut with survey data. needSelection: cuts are available but the user has not picked one yet (the Start manually strategy seeds these). noData: a cut is selected but the survey returned no data. cutMappingIncomplete: no default cut picked yet (fix on the Cut Mappings step).
 */
export enum SurveyReplacementCompositeDataCutRowStatus {
    CUT_SELECTED = 'cutSelected',
    NEED_SELECTION = 'needSelection',
    NO_DATA = 'noData',
    CUT_MAPPING_INCOMPLETE = 'cutMappingIncomplete',
}
